import classNames from 'classnames';
import React from 'react';
import styles from './Section.module.scss';

interface SectionProps {
  children: React.ReactNode;
  noBottom?: boolean;
  noBorder?: boolean;
  backgroundColor?: string;
  style?: React.CSSProperties;
  className?: string;
  standalone?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  backgroundColor,
  noBottom,
  noBorder,
  style,
  standalone,
  className,
  ...props
}) => {
  const containerClass = classNames(
    styles.container,
    {
      [styles.noBottom]: noBottom,
      [styles.noBorder]: noBorder,
      [styles.standalone]: standalone,
    },
    className
  );

  const containerStyle = {
    background: backgroundColor || undefined,
    ...style,
  };

  return (
    <section className={containerClass} style={containerStyle}>
      {props.children}
    </section>
  );
};
